import { useFormContext } from 'react-hook-form'

import { useDebouncedCallback } from '@/hooks'

import { TextInput } from '@/components/atoms'
import { SelectInput } from '@/components/atoms/inputs/SelectInput'

export const CategoriesFilters = () => {
  const { setValue, control } = useFormContext()

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value)
  }

  const debouncedSearch = useDebouncedCallback((value: string) => {
    setValue('filters.search', value)
    setValue('pagination.currentPage', 1)
  }, 400)

  const handleStatusChange = (value: string) => {
    setValue('filters.status', value === 'all' ? null : value)
    setValue('pagination.currentPage', 1)
  }

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <div className="relative w-full sm:w-64">
        <TextInput
          control={control}
          name="filtersForm.search"
          label=""
          placeholder="Search categories…"
          onChange={handleSearchChange}
          className="w-full"
        />
      </div>

      <SelectInput
        name="filters.status"
        placeholder="Filter by status"
        className="w-full sm:w-40"
        options={[
          { label: 'All statuses', value: 'all' },
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
        ]}
        onChange={handleStatusChange}
      />
    </div>
  )
}
